<div class="title-container">
  <smart-input [hideDescription]="true" [key]="'title'" [model]="menu" translationKey="dynamicContent.gastro.title"></smart-input>
  <ibex-checkbox [title]="'dynamicContent.gastro.isOrderable' | translate" [checked]="menu.isOrderable"
                 (click)="menu.isOrderable = $event.val" *ngIf="showOrderField"></ibex-checkbox>
</div>

<div *ngFor="let part of menu.menuParts; let i = index" class="part">
  <mat-form-field><textarea rows="1" (input)="resize($event)" (change)="update($event, i)" matInput>{{ part | nl2Br:'reverse' }}</textarea></mat-form-field>
  <button (click)="removePart(i)" mat-icon-button>
    <mat-icon>delete</mat-icon>
  </button>
</div>

<div class="main-actions">
  <button (click)="addPart()" class="ibexfusion-raised-button" mat-button>
    {{'dynamicContent.gastro.addPart' | translate}}
  </button>
</div>

<div class="footer">
  <div class="container">
    <span class="error" *ngIf="displayError">{{'dynamicContent.gastro.noMenuParts' | translate}}</span>
  </div>
  <div class="container">
    <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{'general.cancel' | translate}}</button>
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</div>
